import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-smart-tooltip',
  templateUrl: './smart-tooltip.component.html',
  styleUrls: ['./smart-tooltip.component.css']
})
export class SmartTooltipComponent implements OnInit {

  @Input() text;
  @Input() limit;

  longText = '';
  shortText = '';

  readMore = false;
  additionalText = '...';

  constructor() { }

  ngOnInit(): void {
    if(!this.text){
      this.text = ''
    }
    if(!this.limit){
      this.limit = 50;
    }
  }

  calculateTexts(){
    if (this.text && this.text.length > 0){
      this.longText = this.text;
      this.shortText = this.text.substr(0, this.limit);
    }
  }

  getTextBuffer(){
    return this.shortText+'...';
  }

  getTooltip(){
    this.calculateTexts();
    return this.longText;
  }

}